<template>
  <BCard
    body-class="border rounded-lg flex flex-column justify-around"
    class="m-0 h-full"
  >
    <div class="flex items-center gap-2 -mt-3 mb-1">
      <h2 class="text-black text-base font-semibold m-0">
        Komcards Skor
      </h2>
      <img
        v-b-tooltip.hover="'Credit Score menggambarkan perilaku pengguna Kartu Komcards'"
        src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
        alt="info"
        width="15"
      >
    </div>
    <div class="hidden" />
    <div class="flex items-center justify-center">
      <div
        id="progress-circle"
        class="relative flex items-center justify-center w-44 h-44 rounded-full transition-all duration-500"
        :style="{ background: progressStyle }"
      >

        <div class="absolute inset-0 m-6 bg-white rounded-full flex flex-col items-center justify-center text-black">
          <span class="text-gray-500 text-base">Skor</span>
          <span
            id="score-text"
            class="text-gray-800 font-medium text-4xl"
          >
            {{ score || 0 }}
          </span>
        </div>
      </div>
    </div>
  </BCard>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'

export default {
  props: {
    score: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    // Logic warna dan gradient dipindah ke sini
    progressStyle() {
      const s = this.score || 0
      let color = ''

      if (s <= 40) {
        color = '#E31A1A' // Merah
      } else if (s <= 60) {
        color = '#FBA63C' // Orange
      } else {
        color = '#34A770'
      }

      return `conic-gradient(${color} ${s}%, #f3f4f6 0%)`
    },
  },
}
</script>
